// extracted by mini-css-extract-plugin
export var cardIcon = "hero-carousel-module--card-icon--94aa6";
export var cardTitle = "hero-carousel-module--card-title--823f0";
export var cardWrapper = "hero-carousel-module--card-wrapper--64470";